'use strict';

var fireEvent = require('./utils/fireEvent.js');

// Example Payload
// {
//     "type": "identify",
//     "userId": "userID",
//     "traits":{
//         "email": "bob@bob.com"
//     },
//     "options":{},
//     "anonymousId": "8fe448a6-1e7a-434b-8374-2bb70c960e4f",
//     "meta":{
//         "rid": "c3556c28-f981-44ac-834c-e925e98ac90c",
//         "ts": 1634856456459,
//         "hasCallback": true
//     }
// }

var identify = function identify(_ref) {
  var _payload$options;
  var config = _ref.config,
    instance = _ref.instance,
    payload = _ref.payload;
  return fireEvent({
    name: (payload === null || payload === void 0 ? void 0 : (_payload$options = payload.options) === null || _payload$options === void 0 ? void 0 : _payload$options.type) || 'user_login',
    config: config,
    instance: instance,
    payload: payload === null || payload === void 0 ? void 0 : payload.traits
  });
};
var identify$1 = identify;

module.exports = identify$1;
//# sourceMappingURL=identify.js.map
